module.exports = __webpack_public_path__ + "img/terry.3fe38964.jpg";